<template>
  <div>
    <div class="container">
      <slot/>
    </div>
  </div>
</template>

<script>
    export default {
        name: "NoSideBar"
    }
</script>
